import { render, staticRenderFns } from "./customer-edit.vue?vue&type=template&id=bba69cc0&"
import script from "./customer-edit.vue?vue&type=script&lang=js&"
export * from "./customer-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports